"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = Dialog;
exports.DialogClose = DialogClose;
exports.DialogContent = DialogContent;
exports.DialogDescription = DialogDescription;
exports.DialogFooter = DialogFooter;
exports.DialogHeader = DialogHeader;
exports.DialogOverlay = DialogOverlay;
exports.DialogPortal = DialogPortal;
exports.DialogTitle = DialogTitle;
exports.DialogTrigger = DialogTrigger;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _focusAutofocusField = require("@design/lib/focus-autofocus-field");
var _radixUi = require("radix-ui");
var _button = require("@design/ui/button");
var _closeButton = require("@design/ui/close-button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className", "children", "showCloseButton", "onOpenAutoFocus"],
  _excluded3 = ["className"],
  _excluded4 = ["className", "showCloseButton", "children"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Dialog(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Root, _objectSpread(_objectSpread({
    "data-slot": "dialog"
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Root",
    "data-sentry-component": "Dialog",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogTrigger(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Trigger, _objectSpread(_objectSpread({
    "data-slot": "dialog-trigger"
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Trigger",
    "data-sentry-component": "DialogTrigger",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogPortal(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Portal, _objectSpread(_objectSpread({
    "data-slot": "dialog-portal"
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Portal",
    "data-sentry-component": "DialogPortal",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogClose(_ref4) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Close, _objectSpread(_objectSpread({
    "data-slot": "dialog-close"
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Close",
    "data-sentry-component": "DialogClose",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogOverlay(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Overlay, _objectSpread(_objectSpread({
    "data-slot": "dialog-overlay",
    className: (0, _utils.cn)("fixed inset-0 isolate z-modal bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", className)
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Overlay",
    "data-sentry-component": "DialogOverlay",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogContent(_ref6) {
  var className = _ref6.className,
    children = _ref6.children,
    _ref6$showCloseButton = _ref6.showCloseButton,
    showCloseButton = _ref6$showCloseButton === void 0 ? true : _ref6$showCloseButton,
    onOpenAutoFocus = _ref6.onOpenAutoFocus,
    props = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogPortal, {
    "data-sentry-element": "DialogPortal",
    "data-sentry-component": "DialogContent",
    "data-sentry-source-file": "dialog.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DialogOverlay, {
      "data-sentry-element": "DialogOverlay",
      "data-sentry-source-file": "dialog.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.Dialog.Content, _objectSpread(_objectSpread({
      "data-slot": "dialog-content",
      onOpenAutoFocus: (0, _focusAutofocusField.focusAutofocusFieldOnOpen)(onOpenAutoFocus),
      className: (0, _utils.cn)("fixed top-1/2 left-1/2 z-modal grid grid-cols-1 fit-wrap max-h-[calc(100%-2rem)] w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border border-border bg-popover p-4 text-sm text-popover-foreground shadow-md duration-100 outline-none overflow-y-auto sm:max-w-(--component-dialog-min-width) data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className)
    }, props), {}, {
      "data-sentry-element": "DialogPrimitive.Content",
      "data-sentry-source-file": "dialog.tsx",
      children: [children, showCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Close, {
        "data-slot": "dialog-close",
        asChild: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
          className: "absolute top-4 right-4"
        })
      })]
    }))]
  });
}
function DialogHeader(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "dialog-header",
    className: (0, _utils.cn)("flex flex-col gap-4 pr-8", className)
  }, props), {}, {
    "data-sentry-component": "DialogHeader",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogFooter(_ref8) {
  var className = _ref8.className,
    _ref8$showCloseButton = _ref8.showCloseButton,
    showCloseButton = _ref8$showCloseButton === void 0 ? false : _ref8$showCloseButton,
    children = _ref8.children,
    props = _objectWithoutProperties(_ref8, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    "data-slot": "dialog-footer",
    className: (0, _utils.cn)("flex flex-row flex-wrap justify-end gap-3", className)
  }, props), {}, {
    "data-sentry-component": "DialogFooter",
    "data-sentry-source-file": "dialog.tsx",
    children: [children, showCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Close, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        variant: "outline",
        children: "Close"
      })
    })]
  }));
}
function DialogTitle(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Title, _objectSpread(_objectSpread({
    "data-slot": "dialog-title",
    className: (0, _utils.cn)("fit-wrap min-w-0 text-base leading-6 font-medium text-foreground", className)
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Title",
    "data-sentry-component": "DialogTitle",
    "data-sentry-source-file": "dialog.tsx"
  }));
}
function DialogDescription(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Dialog.Description, _objectSpread(_objectSpread({
    "data-slot": "dialog-description",
    className: (0, _utils.cn)("fit-wrap min-w-0 text-sm text-foreground *:[a]:underline *:[a]:underline-offset-3", className)
  }, props), {}, {
    "data-sentry-element": "DialogPrimitive.Description",
    "data-sentry-component": "DialogDescription",
    "data-sentry-source-file": "dialog.tsx"
  }));
}